import { GeothermalDesignDocumentsSystemDetails, GeothermalLoopFieldPackage } from 'types';

import { api } from './api';

export const loopFieldPackageApi = api.injectEndpoints({
  endpoints: (build) => ({
    saveLoopFieldPackage: build.mutation<
      any,
      {
        accountId: string;
        savePackage: Partial<GeothermalLoopFieldPackage>;
        systemDetails?: GeothermalDesignDocumentsSystemDetails;
      }
    >({
      query: ({ accountId, savePackage, systemDetails }) => ({
        url: `v2/accounts/${accountId}/loop-field-package/save`,
        method: 'POST',
        body: { ...savePackage, ...(systemDetails ? { systemDetails } : {}) },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'SystemDesign', id: arg?.accountId },
      ],
    }),
    submitLoopFieldPackage: build.mutation<
      any,
      {
        accountId: string;
        loopFieldPackage: GeothermalLoopFieldPackage;
        systemDetails?: GeothermalDesignDocumentsSystemDetails;
      }
    >({
      query: ({ accountId, loopFieldPackage, systemDetails }) => ({
        url: `v2/accounts/${accountId}/loop-field-package/submit`,
        method: 'POST',
        body: { ...loopFieldPackage, ...(systemDetails ? { systemDetails } : {}) },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'Queues', accountId: arg?.accountId },
        { type: 'SystemDesign', id: arg?.accountId },
        { type: 'AccountMilestones', id: arg?.accountId },
      ],
    }),
    getLoopFieldPackage: build.query<GeothermalLoopFieldPackage, { accountId: string }>({
      query: ({ accountId }) => ({
        url: `v2/accounts/${accountId}/loop-field-package`,
      }),
      providesTags: (_result, _error, arg) => [{ type: 'Accounts', id: arg?.accountId }],
    }),
    submitLoopFieldDesignDocuments: build.mutation<
      void,
      { accountId: string; systemDetails: GeothermalDesignDocumentsSystemDetails }
    >({
      query: ({ accountId, systemDetails }) => ({
        url: `v2/accounts/${accountId}/loop-field-design-documents/submit`,
        method: 'POST',
        body: { ...systemDetails },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'Queues', accountId: arg?.accountId },
        { type: 'AccountMilestones', id: arg?.accountId },
      ],
    }),
  }),
});

export const {
  useSaveLoopFieldPackageMutation,
  useSubmitLoopFieldPackageMutation,
  useGetLoopFieldPackageQuery,
  useSubmitLoopFieldDesignDocumentsMutation,
} = loopFieldPackageApi;
